import { createStyles, makeStyles, Theme } from "@material-ui/core";
import styled from "styled-components";

export interface AddItemPageStylesProps { }
export const useStyles = makeStyles<Theme, AddItemPageStylesProps>((theme: Theme) =>
  createStyles({
    buttonWrapper: {
      display: "flex",
      justifyContent: "center",
      margin: theme.spacing(2),
      width: "auto",
      marginTop: 50,
      marginBottom: 73,
    },
    buttonWrapper2: {
      marginTop: 50,
    },
    customSubmitButton: {
      width: "250px",
      display: "block",
      justifyContent: "center",
      alignItems: "center",
      margin: "0 auto",
      "& span": {
        fontWeight: 700,
      },
    },
    addItemPageTableWrapper: {
      overflowX: "hidden",
      "& table": {
        tableLayout: "auto",
      },
      "& .MuiTableCell-root": {
        whiteSpace: "normal",
        overflowWrap: "anywhere",
        wordBreak: "keep-all",
        fontSize: "12px",
      },
      "& .MuiTableCell-root:first-child": {
        width: "90px",
        minWidth: "90px",
        maxWidth: "90px",
      },
      "& .MuiTableCell-root:nth-child(2)": {
        width: "95px",
      },
      "& .MuiTableCell-root:nth-child(3)": {
        width: "95px",
      },
      "& .MuiTableCell-root:nth-child(4)": {
        width: "60px",
      },
      "& .MuiTableCell-root:nth-child(5)": {
        width: "55px",
      },
      "& .MuiTableCell-root:nth-child(6)": {
        width: "50px",
      },
      "& .MuiTableCell-root:nth-child(7)": {
        width: "50px",
      },
      "& .MuiTableCell-root:nth-child(9)": {
        width: "30px",
      },
      "& .MuiTableCell-root:last-child": {
        minWidth: "10px",
        maxWidth: "10px",
        width: "10px",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
      },
      "& .MuiTableCell-root:nth-last-child(2)": {
        minWidth: "10px",
        maxWidth: "10px",
        width: "10px",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
      },
    },
    breadcrumbsContainer: {
      marginBottom: "40px",
      width: "95%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
  }),
);

export const ButtonWrapper = styled.div`
  .MuiButton-root {
    width: 100%;
    height: 70px;
    margin-top: 30px;
  }
  width: 40%;
  button:first-child {
    margin-right: 25px;
  }
  .MuiButton-text {
    margin-left: 25px;
    margin-right: 0px !important;
  }
  @media screen and (max-width: 600px) {
    button:first-child {
      margin-right: 10px;
      font-size: 16px;
      height: 60px;
    }
    .MuiButton-text {
      margin-left: 10px;
      font-size: 20px;
    }
  }
`;

export const ButtonsWrapper = styled.div`
display: flex;
justify-content: center;
`;

